import * as React from 'react';
import { useHistory } from 'react-router';
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles, useMediaQuery } from '@material-ui/core';
import { Receipt as ReceiptModel } from '../../models/postcheckout/Receipt';
import CheckDetails from '../common/CheckDetails';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { String_Receipt_ReceiptTitle, String_Receipt_CheckLabel, String_Receipt_PaidDateTimeLabel, 
    String_Receipt_AuthCodeLabel, String_Receipt_CardNumberLabel, String_Receipt_CardTypeLabel,
    String_ViewReceipt_DemoInfo, String_ViewReceipt_DemoThankYou,
    String_Check_PayCheckButton} from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';
import { CheckOutType } from '../../models/common/CheckOutType';
import { Skin } from '../../models/common/Skin';
import FullWidthButton, { FullWidthButtonProps, FullWidthButtonSize } from '../common/Buttons/FullWidthButton';

const useStyles = makeStyles({
    checkDetailsContainer: {
        backgroundColor: themePrimary.palette.grey[100],
        borderRadius: '6px',
        marginLeft:  ElementDimensions.margin10 + 'px',
        marginRight:  ElementDimensions.margin10 + 'px',
    },
    demoClickHereContainer: {
        marginTop: '10px',
        fontFamily: 'LeagueSpartan-Bold !important',
        color:  props => (props as Skin).primary_main_color + ' !important',
    },
    demoClickHereLink: {
        fontFamily: 'LeagueSpartan-Bold !important',
        color:  props => (props as Skin).primary_main_color + ' !important',
    },
    demoContainer: {
        display: 'flex',
        textAlign: 'center',
        marginTop: ElementDimensions.margin40 + 'px'
    },
    demoInnerContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    demoTextThankYou: {
        fontFamily: 'LeagueSpartan-Bold !important',
        color:  props => (props as Skin).primary_main_color + ' !important',
    },
    details: {
        position: 'absolute',
        top: ElementDimensions.appBarHeight + 'px',
        bottom:  props => (props as CheckReceiptStyleProps).hasFooterBar === true ? ElementDimensions.footerBarHeight + 'px' : ElementDimensions.footerBarHeightReceiptScreen + 'px',
        left: 0,
        right: 0,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsLandscape: {
        position: 'absolute',
        top: '0px',
        bottom: props => (props as CheckReceiptStyleProps).hasFooterBar === true ? ElementDimensions.footerBarHeightLandscape + 'px' : 0,
        left: 'calc(100vw *.3)',
        width: 'calc(100vw *.7)',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    headerContainer: {
        paddingLeft: ElementDimensions.padding10 + 'px',
        paddingRight: ElementDimensions.padding10 + 'px',
        paddingTop: ElementDimensions.padding5 + 'px',
        paddingBottom: ElementDimensions.padding5 + 'px',
        width: '100%',
    },
    headerGrid: {
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        width: '100%',
    },
    headerGridContainer: {
        display: 'flex',
    },
    headerTextLeft: {
        fontSize: '1rem',
        lineHeight: '1.6rem',  
        color: themePrimary.palette.secondary.contrastText,
    },
    headerTextRight: {
        fontSize: '1rem',
        lineHeight: '1.6rem',  
        textAlign: 'right',
        color: themePrimary.palette.secondary.contrastText,
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif !important",
    },
    titleContainer: {
        height: ElementDimensions.headerBarHeight + 'px',
        display: 'flex',
        textAlign: 'center',
        padding: ElementDimensions.padding5 + 'px',
    },
    titleInnerContainer: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
});

export type CheckReceiptStyleProps = {
    hasFooterBar: boolean
}

export interface CheckReceiptProps {
    receipt: ReceiptModel,
    hasFooterBar: boolean,
    isDemo: boolean,
}

const CheckReceipt = (props: CheckReceiptProps) => {
    const { receipt, hasFooterBar, isDemo } = props;
    const isPortrait = true;
    let history = useHistory();
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color,
        hasFooterBar: hasFooterBar ? true : false });

    const handleDemoLinkClick = (event: React.MouseEvent<HTMLElement>) => {
        window.location.href = "https://mtechmobility.com/about-mtech/contact-us/"
    }

    const fullWidthButtonProps: FullWidthButtonProps = {
            disabled: false,
            label: 'Click Here',
            alternateColor: false,
            size: FullWidthButtonSize.Small,
            onClickHandler: handleDemoLinkClick,
            }

    return (
        <div>
            <div className={isPortrait === true ? classes.details : classes.detailsLandscape}>
                <div className={classes.titleContainer}>
                    <div className={classes.titleInnerContainer}>
                        <Typography variant="h6">
                            {String_Receipt_ReceiptTitle.find(s => s.key === userState.state.locale)!!.value}
                        </Typography>
                    </div>
                </div>
                <div className={classes.headerContainer}>
                    <div className={classes.headerGridContainer}>
                        <div className={classes.headerGrid}>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_CheckLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.check_number}
                            </div>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_PaidDateTimeLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.check_paid_date_time}
                            </div>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_CardTypeLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.payment_method}
                            </div>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_CardNumberLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.card_number}
                            </div>
                            <div className={classes.headerTextLeft}>
                                {String_Receipt_AuthCodeLabel.find(s => s.key === userState.state.locale)!!.value}
                            </div>
                            <div className={classes.headerTextRight}>
                                {receipt.auth_code}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.checkDetailsContainer}>
                    <CheckDetails  details={receipt.check.details} isReceipt={true}/>
                </div>
                {isDemo && checkOutState.state.restaurantName!!.includes("Touch") &&
                    <div className={classes.demoContainer}>
                        <div className={classes.demoInnerContainer}>
                            <Typography variant="h4" className={classes.demoTextThankYou}>
                                {String_ViewReceipt_DemoThankYou.find(s => s.key === userState.state.locale)!!.value}
                            </Typography>
                            <Typography variant="h6">
                                {String_ViewReceipt_DemoInfo.find(s => s.key === userState.state.locale)!!.value}
                            </Typography>
                            <br/>
                            <FullWidthButton 
                                disabled={fullWidthButtonProps.disabled}
                                label={fullWidthButtonProps.label}
                                alternateColor={fullWidthButtonProps.alternateColor}
                                size={fullWidthButtonProps.size}
                                onClickHandler={fullWidthButtonProps.onClickHandler}/>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default CheckReceipt;